module.exports = __webpack_public_path__ + "img/bz_thumb.92bf7127.gif";